import { contains, isEmpty } from 'underscore';
import { withValidation, withError, AdapterFactory } from '@bingads-webui-react/validation';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';
import { LanguageTarget, campaignLanguageStrings } from '@bingads-webui-campaign-react/language-target';
import { get } from '@bingads-webui-component-legacy/language-selector/util/defaultLanguage';

export { campaignLanguageStrings };

const LanguageTargetValidationAdapter = AdapterFactory({
  defaultValue: [],
  valueToInject: 'selectedLanguages',
  functionToInject: 'setSelectedLanguages',
});

export const getDefaultLanguage = (permissions, locale) => {
  const { LANGUAGES: supportedLanguages } = globalizationModelSetup({ permissions, culture: locale });
  let defaultLanguage = [get()].filter(language => contains(supportedLanguages, language));
  if (isEmpty(defaultLanguage)) {
    defaultLanguage = [];
  }
  return defaultLanguage;
};

export const LanguageTargetValidatorFactory = i18n => function LanguageTargetValidator(value, defaultValidator) {
  const defaultErrors = defaultValidator(value);
  return [
    ...isEmpty(defaultErrors) ? [] : defaultErrors,
    ...value.length < 1 ? [i18n.getString(_TL_('Select at least one language'))] : [],
  ];
};

export const ValidatedLanguageTarget = withError(withValidation(LanguageTarget, LanguageTargetValidationAdapter));
